import { Col, Form, Row } from 'antd';

import { SPACE_MD } from '@/theme/buildAntdTheme';

import { evaluateHidden, getFieldKey, SchemaField } from './schemaFieldUtils';
import {
  getFormSizeTokens,
  type FormSize,
  type FormSizeTokens,
} from './sizing';

import type { FieldConfig, SectionConfig } from './types';

type SchemaSectionFieldsProps = {
  section: Pick<SectionConfig, 'fields' | 'hidden'>;
  size?: FormSize;
  tokens?: FormSizeTokens;
  formValues?: Record<string, unknown>;
};

const SchemaSectionFields = ({
  section,
  size = 'default',
  tokens: tokensProp,
  formValues: formValuesProp,
}: SchemaSectionFieldsProps) => {
  const form = Form.useFormInstance();
  const watchedValues = Form.useWatch([], form) as
    Record<string, unknown> | undefined;
  const formValues = formValuesProp ?? watchedValues ?? {};
  const tokens = tokensProp ?? getFormSizeTokens(size);

  if (evaluateHidden(section.hidden, formValues)) {
    return null;
  }

  return (
    <>
      {section.fields
        .filter(
          (field) =>
            field.type === 'hidden' &&
            !evaluateHidden(field.hidden, formValues),
        )
        .map((field: FieldConfig) => (
          <SchemaField
            key={getFieldKey(field)}
            field={field}
            tokens={tokens}
            formValues={formValues}
          />
        ))}
      <Row gutter={SPACE_MD}>
        {section.fields
          .filter(
            (field) =>
              field.type !== 'hidden' &&
              !evaluateHidden(field.hidden, formValues),
          )
          .map((field: FieldConfig) => (
            <Col key={getFieldKey(field)} xs={24} md={field.colSpan ?? 24}>
              <SchemaField
                field={field}
                tokens={tokens}
                formValues={formValues}
              />
            </Col>
          ))}
      </Row>
    </>
  );
};

export default SchemaSectionFields;
